import React, {useEffect, useState, type JSX} from 'react';
import {useIntl} from 'react-intl';
import {Button, SPACE, WheelPicker} from '@lookiero/aurora';

import {MountableModal} from '@components/molecules';

import {FREQUENCY_DAY_SELECTOR, RecurrentModalities} from '../MyPlan.definition';
import {FREQUENCY_INFO, TEXT} from './ModalFrequencySelectDay.definition';

const DAYS_IN_MONTH = Array.from({length: 30}, (_item, day) => day + 1);

type ModalFrequencySelectDayProps = {
  day?: number;
  isVisible: boolean;
  modality: RecurrentModalities;
  onClose: () => void;
  onSubmit: (value: number) => void;
  busy?: boolean;
};
export const ModalFrequencySelectDay = ({
  day = 1,
  isVisible,
  modality,
  onClose,
  onSubmit,
  busy = false,
}: ModalFrequencySelectDayProps): JSX.Element => {
  const {formatMessage} = useIntl();
  const [selectedDay, setSelectedDay] = useState(day);

  useEffect(() => {
    if (isVisible) setSelectedDay(day);
  }, [isVisible, day]);

  return (
    <MountableModal
      portalID="modal-frequencyday"
      isVisible={isVisible}
      onClose={onClose}
      title={formatMessage(FREQUENCY_INFO[modality].subtitle)}
    >
      <WheelPicker
        marginBottom={SPACE.SPACE_6}
        onChange={(index: number) => setSelectedDay(index + 1)}
        options={DAYS_IN_MONTH.map(day => formatMessage({id: FREQUENCY_DAY_SELECTOR[modality]}, {day}))}
        selected={selectedDay - 1}
        wide
      />
      <Button onPress={() => onSubmit(selectedDay)} disabled={day === selectedDay} busy={busy}>
        {formatMessage(TEXT.MODAL_DAY_CTA)}
      </Button>
    </MountableModal>
  );
};
